import React from 'react';
import HeroSection from '../components/HeroSection/HeroSection';
import PolicySection from '../components/PolicySection/PolicySection';
import ParallaxSection from '../components/ParallaxSection/ParallaxSection';
import { policiesContent } from '../content/policies';
import SEO from '../components/seo';

const Policies = () => {
  return (
    <React.Fragment>
      <SEO title={"Policies"} />
      <HeroSection {...policiesContent.heroSection} />
      <PolicySection {...policiesContent.refundPolicy} />
      <PolicySection {...policiesContent.deliveryPolicy} />
      <PolicySection {...policiesContent.returnPolicy} />
      <PolicySection {...policiesContent.cancellationPolicy} />
      <PolicySection {...policiesContent.privacyPolicy} />
      <ParallaxSection {...policiesContent.parallax} />
    </React.Fragment>
  );
};

export default Policies;
